import {range, includes, split, toNumber} from 'vendor';
import {fullday, minutes, minutesToTime} from 'helpers/minutes';
import {perDay} from './per-day';
import type {Activity} from 'types';

export const times = (activity: Activity | undefined) => {
  if (includes(activity?.times, ',')) {
    return split(activity?.times, ', ').filter(Boolean);
  } else if (activity?.time && parseInt(activity?.timeInterval)) {
    return range(perDay(activity))
      .map(index => minutes(activity.time) + index * toNumber(activity.timeInterval))
      .filter(value => value <= fullday)
      .map(minutesToTime);
  }
  return activity?.time ? [activity?.time] : [];
};
